const SettingsContainer = ({ children }) => {
  return (
    <div className="border-y-4 lg:border-y-0 lg:border-x-4 border-green min-h-screen bg-dark-600 p-6 lg:p-20">
      {children}
    </div>
  );
};

export default SettingsContainer;
